import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../../app.json";
import NewFluidIntake from "./NewFluidIntake";
import FoodIntakeList from "./FluidIntakeList";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { LIST, CREATE } from "../../../../queries/fluid.query";
import LoadingSpinner from "../../../../partials/loading";
import AlertMessage from "../../../../partials/alertMessage";
import { ReadData } from "../../../../providers/Patient.Provider";

const FluidIntake = ({ location }) => {
    const [newForm, setNewForm] = useState(false);
    const [fluid, setFluid] = useState(null);

    // local data
    const patient = ReadData();
    // query
    const { loading, error, data } = useQuery(LIST, {
        variables: { id: patient.lastAdmission || patient.id }
    });

    const Cancel = () => {
        setNewForm(false);
        scrollTop();
        setFluid(null);
    };
    // Mutation
    const [CreateFunc, { loading: cLoading, data: cData, error: cError }] = useMutation(CREATE, {
        update(caches, { data: { NewFluidIntake } }) {
            const { GetFluidIntakes } = caches.readQuery({
                query: LIST,
                variables: { id: patient.lastAdmission || patient.id }
            });
            // Add to list
            GetFluidIntakes.docs.unshift(NewFluidIntake.doc);
            caches.writeQuery({
                query: LIST,
                variables: { id: patient.lastAdmission || patient.id },
                data: { GetFluidIntakes }
            });
        }
    });

    function scrollTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }

    return (
        <>
            <Helmet>
                <title>Patient Fluid | {appName}</title>
            </Helmet>
            <div className="row justify-content-center">
                {newForm && !fluid && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <button onClick={Cancel} title="Back" className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored">
                                        <i className="material-icons text-primary">keyboard_backspace</i>
                                    </button>
                                    Record Fluid Intake
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={cLoading} />
                                <AlertMessage message={cError && cError.message} failed={true} />
                                <AlertMessage message={cData && cData.NewFluidIntake.message} />

                                <NewFluidIntake
                                    onCancel={Cancel}
                                    onSubmit={async item => {
                                        await CreateFunc({
                                            variables: {
                                                model: {
                                                    ...item,
                                                    admission: patient.lastAdmission,
                                                    patient: patient.id
                                                }
                                            }
                                        });
                                        setTimeout(() => {
                                            setNewForm(false);
                                            scrollTop();
                                        }, 500);
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
                {!newForm && !fluid && (
                    <div className="col-12 fade-in">
                        <div className="card">
                            <div className="card-head">
                                <header>Recorded Fluid Intake</header>
                                <div className="tools">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setNewForm(true);
                                            scrollTop();
                                            setFluid(null);
                                        }}
                                        className="mdl-button mdl-button--icon btn-primary"
                                    >
                                        <i className="material-icons">add</i>
                                    </button>
                                </div>
                            </div>
                            <div className="card-body" style={{ minHeight: "420px" }}>
                                <LoadingSpinner loading={loading} />
                                <AlertMessage message={error && error.message} failed={true} />
                                {!loading && (
                                    <FoodIntakeList
                                        className="fade-in"
                                        items={data && data.GetFluidIntakes.docs}
                                        onView={item => {
                                            setNewForm(false);
                                            scrollTop();
                                            setFluid(item);
                                        }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default FluidIntake;
